{
  "version": 1,
  "asset_id": "862a4cc4-1f0e-4bbe-9af6-bf2abcfefef6",
  "project_id": "115256dd-a6cc-4bc1-95c1-d787d4c0e481",
  "url": "/__l5e/assets-v1/862a4cc4-1f0e-4bbe-9af6-bf2abcfefef6/rv_towing.webp",
  "r2_key": "a/v1/115256dd-a6cc-4bc1-95c1-d787d4c0e481/862a4cc4-1f0e-4bbe-9af6-bf2abcfefef6/rv_towing.webp",
  "original_filename": "rv_towing.webp",
  "size": 37298,
  "content_type": "image/webp",
  "created_at": "2026-07-14T02:53:38Z"
}
